import { useNavigate } from "react-router-dom";
// @ts-ignore
import { LockClosedIcon } from "@heroicons/react/outline";

const NoPermissionPage = () => {
  const navigate = useNavigate();
  const HandleReDirect = () => {
    window.location.href = "https://sso.edkamm.com/login";
  };
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <LockClosedIcon className="h-24 w-24 text-red-500 mx-auto mb-4" />
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Access Denied</h1>
        <p className="text-gray-600 text-lg mb-6">
          You do not have permission to view this page.
        </p>
        <button
          className="px-6 py-3 bg-blue-600 text-white rounded-2xl hover:bg-blue-700 transition"
          onClick={HandleReDirect}
        >
          Back To SSO
        </button>
      </div>
    </div>
  );
};

export default NoPermissionPage;
